/**
 * @generated SignedSource<<197891c798701639dd80d67110133886>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskShortConnectionFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly cursor: string;
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"TaskShortFragment">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"PageInfoFragment">;
  } | null | undefined;
  readonly structure: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"StructureFragment">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "TaskShortConnectionFragment";
};
export type TaskShortConnectionFragment$key = {
  readonly " $data"?: TaskShortConnectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskShortConnectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskShortConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TaskShortFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Structure",
      "kind": "LinkedField",
      "name": "structure",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StructureFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskConnection",
  "abstractKey": null
};

(node as any).hash = "af2550df1f5feab8e290802eaff8865c";

export default node;
